// ============================================================================
// HealthDot — coloured pill + dot for signal-health states.
//
// Three known states map to deterministic colours:
//   HOLD          → green   (thesis intact)
//   MONITOR       → amber   (watch closely)
//   CONSIDER EXIT → red     (thesis broken)
// Any other string falls back to muted grey so unknown future states don't
// crash the UI.
// ============================================================================

const COLOURS = {
  HOLD: 'var(--green)',
  MONITOR: 'var(--amber)',
  'CONSIDER EXIT': 'var(--red)',
};

export default function HealthDot({ state }) {
  const col = COLOURS[state] || 'var(--text-muted)';
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      fontSize: 10,
      fontWeight: 700,
      color: col,
      whiteSpace: 'nowrap',
    }}>
      <span style={{
        width: 6, height: 6,
        borderRadius: '50%',
        background: col,
        boxShadow: `0 0 6px ${col}`,
      }} />
      {state}
    </span>
  );
}
